import { useTenant } from "./useTenant";
import { isStaffRole } from "@/lib/staffAccess";

/**
 * True when the current user is a restricted "staff" member of the active salon
 * (own-calendar-only login). UI gate only — RLS is the real barrier.
 */
export function useIsStaff(): boolean {
  const { currentTenant } = useTenant();
  return isStaffRole(currentTenant?.userRole);
}
